import { css } from '@emotion/react';
import React from 'react';

import { IngridLogo } from '~src/commons/components/logo/ingrid-logo';
import { PoweredByLogo } from '~src/commons/components/logo/powered-by-logo';
import { useTranslations } from '~src/commons/utils/translations/translate';
import { useGlobalState } from '~src/global-state';
import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';

export const Footer: React.FC = () => {
  const globalState = useGlobalState();
  const session = globalState.sessions[0];
  const isSplitDelivery = globalState.sessions.length > 1;
  const isBillingAddressDisabled = !globalState.flags.show_billing_address;
  // TODO: should this reside on session ?
  const { show_privacy_policy, show_slogan, enable_ingrid_logo } = session.flags;

  const addAdditionalMarginTop = isSplitDelivery && isBillingAddressDisabled;

  if (!enable_ingrid_logo && !show_privacy_policy) {
    return null;
  }

  return (
    <div css={styles.wrapper(addAdditionalMarginTop)} aria-label="Footer">
      <div css={styles.logos}>
        {(show_privacy_policy || globalState.use_recipient_address) && <PrivacyPolicyLink />}
      </div>
      <div css={styles.logos}>
        {enable_ingrid_logo && show_slogan && (
          <PoweredByLogo css={styles.slogan} fill={colors.black} />
        )}
        {enable_ingrid_logo && <IngridLogo fill={colors.black} />}
      </div>
    </div>
  );
};

const PrivacyPolicyLink: React.FC = () => {
  const { tICU } = useTranslations();

  return (
    <a
      tabIndex={0}
      css={styles.privacyPolicyLink}
      className="focus-visible-outline"
      rel="noreferrer"
      href="https://www.ingrid.com/privacy-policy"
      target="_blank"
    >
      {tICU('widget.PRIVACY_POLICY')}
    </a>
  );
};

const styles = {
  wrapper: (addAdditionalMarginTop?: boolean) =>
    css({
      borderTop: `1px solid ${colors.neutral90}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 0 18px',
      ...(addAdditionalMarginTop && { marginTop: '16px' }),
    }),
  slogan: {
    marginRight: '4px',
  },
  privacyPolicyLink: {
    ...fontStyles.px12_16,
    textDecoration: 'none',
    letterSpacing: '0.1px',
    color: colors.neutral35,
    '&:hover': {
      color: colors.neutral35,
      textDecoration: 'underline',
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  logos: {
    display: 'flex',
    alignItems: 'baseline',
  },
};
